import { WriteOffStatus } from '@repo/types';

import { useDarkMode } from '@xtnd/web/shared';

import { WRITEOFF_STATUS_OPTIONS } from '../../constants/writeOffs';

interface WriteOffStatusBadgeProps {
  status: WriteOffStatus;
  isStrikeThrough?: boolean;
}

export const WriteOffStatusBadge = ({ status, isStrikeThrough }: WriteOffStatusBadgeProps) => {
  const { isDark } = useDarkMode();
  const mode = isDark ? 'dark' : 'light';

  const option = WRITEOFF_STATUS_OPTIONS[mode][status];
  const label = option?.label ?? status;
  const colorClass = option?.colorClass ?? 'text-gray-600 bg-gray-100 border-gray-300';
  const strikeClass = isStrikeThrough ? 'line-through opacity-60' : '';

  return (
    <span
      className={`text-sm inline-flex items-center px-2 py-1 rounded-full ${colorClass} ${strikeClass} truncate`}
      title={label}
    >
      {label}
    </span>
  );
};
